<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARITE PAIEMENT-->
        <div>
          <div class="justify-content-center row margin pt-5" style="float: left">
            <div class="trigger pb-5" style="z-index: 1">
              <span>
                                          <img class="mr-3" loading="lazy" src="../../assets/img/writing.png" width="25px"  alt="writing quotes">

                {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                             class="ml-4 fas fa-chevron-down"></i></span>
              <ul class="devis elevation-24">
                <li class="font-weight-bold" style="cursor:pointer">Particulier</li>
                <li><a href="/devis/auto"><i><img   class="mr-2" width="35" src="../../assets/img/icones/menu/cars_quote.png"
                                                  :alt="$t('home_page.bouton_devis[1]')"/></i>
                  {{ $t('home_page.bouton_devis[1]') }}</a></li>
                <li><a href="/devis/habitation"><i><img   class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/house_quote.png"
                                                        :alt="$t('home_page.bouton_devis[2]')"/></i>
                  {{ $t('home_page.bouton_devis[2]') }}</a></li>
                <li><a href="/devis/voyage"><i><img   class="mr-2" width="35"
                                                    src="../../assets/img/icones/menu/travel_quote.png"
                                                    :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                    $t('home_page.bouton_devis[3]')
                  }}</a></li>
                <li><a href="/devis/sante"><i><img   class="mr-2" width="35"
                                                   src="../../assets/img/icones/menu/health_quote.png"
                                                   :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                    $t('home_page.bouton_devis[4]')
                  }}</a></li>
                <li><a href="/devis/vie"><i><img   class="mr-2" width="35" src="../../assets/img/icones/menu/life_quote.png"
                                                 :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                    $t('home_page.bouton_devis[5]')
                  }}</a></li>
                <li><a href="/plus"><i><img   class="mr-2" width="35" src="../../assets/img/icones/menu/add_quote.png"
                                            :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                    $t('home_page.bouton_devis[6]')
                  }}</a></li>
                <li class="font-weight-bold" style="cursor:pointer">Entreprise</li>
                <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                <li><a href="/devis/auto"><i><img   class="mr-2" width="30" src="../../assets/img/icones/menu/mrp_quote.png"
                                                  alt="devis_mrp"/></i> MRP</a></li>
                <li><a href="/devis/habitation"><i><img   class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/trc_quote.png" alt="devis_trc"/></i>TRC</a>
                </li>
                <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
              </ul>
            </div>

            <div class="trigger-simulation ml-4 pb-5" style="z-index: 1">
              <span>
                          <img class="mr-3" loading="lazy" src="../../assets/img/rocket.png" width="25px"  alt="writing quotes">

                {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                             class="ml-4 fas fa-chevron-down"></i></span>
             <ul class="devis elevation-24">
                      <li><a href="/simulate/devis/auto"><i><img   class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/simulate/devis/voyage"><i><img   class="mr-2" width="35"
                                                          src="../../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                    </ul>
            </div>
          </div>

          <div class="justify-content-center row margin pt-5 mt-2" style="float: right">
            <div class="justify-content-center row border-radius logo-paiement">
              <img   width="60" height="30" alt="orange-money-logo" src="../../assets/img/logoPaiement/orange-money.png"/>
              <img   width="60" height="30" alt="free-money-logo" src="../../assets/img/logoPaiement/freemoney.png"/>
              <img   class="pt-1" width="60" height="25" alt="visa-logo"
                   src="../../assets/img/logoPaiement/visa.png"/>
              <img   class="ml-2" width="60" height="30" alt="master-card-logo" src="../../assets/img/logoPaiement/master-card.png"/>
              <img   class="ml-2" width="30" height="30" alt="wave-logo" src="../../assets/img/logoPaiement/wave.png"/>
              <img   class="ml-3" width="30" height="30" alt="kpay-logo" src="../../assets/img/logoPaiement/kpay_logo.webp"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div style="margin-top:50px" v-responsive.sm.xs>
      <div>

        <!--PARITE PAIEMENT-->
        <div style="background: #ffffff;height:auto">
          <div class="column pb-5" style="z-index: 1!important;">
            <div class="justify-content-center row">
               <div class="trigger" style="z-index: 2!important;">
                    <span>
                                                <img class="mr-3" loading="lazy" src="../../assets/img/writing.png" width="25px"  alt="writing quotes">

                      <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                      {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                                   class="ml-4 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24">
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
                      <li><a href="/devis/auto"><i><img   class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/devis/habitation"><i><img   class="mr-2" width="35"
                                                              src="../../assets/img/icones/menu/house_quote.png"
                                                              :alt="$t('home_page.bouton_devis[2]')"/></i>
                        {{ $t('home_page.bouton_devis[2]') }}</a></li>
                      <li><a href="/devis/voyage"><i><img   class="mr-2" width="35"
                                                          src="../../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                      <li><a href="/devis/sante"><i><img   class="mr-2" width="35"
                                                         src="../../assets/img/icones/menu/health_quote.png"
                                                         :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                          $t('home_page.bouton_devis[4]')
                        }}</a></li>
                      <li><a href="/devis/vie"><i><img   class="mr-2" width="35"
                                                       src="../../assets/img/icones/menu/life_quote.png"
                                                       :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                          $t('home_page.bouton_devis[5]')
                        }}</a></li>
                      <li><a href="/plus"><i><img   class="mr-2" width="35" src="../../assets/img/icones/menu/add_quote.png"
                                                  :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                          $t('home_page.bouton_devis[6]')
                        }}</a></li>
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
                      <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                      <li><a href="/devis/mrp"><i><img   class="mr-2" width="30"
                                                       src="../../assets/img/icones/menu/mrp_quote.png"
                                                       alt="devis_mrp"/></i> MRP</a></li>
                      <li><a href="/devis/trc"><i><img   class="mr-2" width="35"
                                                       src="../../assets/img/icones/menu/trc_quote.png"
                                                       alt="devis_trc"/></i>TRC</a></li>
                                                       <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
                    </ul>
                  </div>
            </div>

            <div class="justify-content-center row">
             <div class="trigger-simulation mt-4">
                    <span>
                                                <img class="mr-3" loading="lazy" src="../../assets/img/rocket.png" width="25px"  alt="writing quotes">

                      <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                      {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                                   class="ml-4 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24">
                      <li><a href="/simulate/devis/auto"><i><img   class="mr-2" width="35"
                                                        src="../../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/simulate/devis/voyage"><i><img   class="mr-2" width="35"
                                                          src="../../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                    </ul>
                  </div>
            </div>

            <div class="justify-content-center row mt-5" style="z-index: 1!important;">
              <div class="justify-content-center row border-radius logo-paiement mt-2">
                <img   width="50" height="30" alt="orange-money-logo" src="../../assets/img/logoPaiement/orange-money.png"/>
                <img   width="60" height="30" alt="free-money-logo" src="../../assets/img/logoPaiement/freemoney.png"/>
                <img   class="pt-1" width="60" height="25" alt="visa-logo" src="../../assets/img/logoPaiement/visa.png"/>
                <img   class="ml-1" width="60" height="30" alt="master-card-logo" src="../../assets/img/logoPaiement/master-card.png"/>
                <img   class="ml-2" width="30" height="30" alt="wave-logo" src="../../assets/img/logoPaiement/wave.png"/>
                <img   class="ml-3" width="30" height="30" alt="kpay-logo"
                     src="../../assets/img/logoPaiement/kpay_logo.webp"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';


export default {
  name: 'payment_partner_section',
  components: {
    simplebar

  },
  data: () => ({    
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.'

  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },
  mounted() {
  window.scrollTo(0, 0);  
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.newsletter_titre_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  margin-top: 6%;
  text-align: center;
}

.margin {
  margin-left: 9%;
  margin-right: 9%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}


h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}


.trigger {
  width: 240px;
}

.trigger span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}

.trigger:hover ul.devis a {
  opacity: 1;
}





.trigger-simulation {
  width: 240px;
}

.trigger-simulation span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5B94BC;
  color: #000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger-simulation:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
}

.trigger-simulation:hover ul.devis a {
  opacity: 1;
}

/*---------- testimonial css start ----------*/
.pn_testimonial_box {
  font-weight: 300;
  padding: 2rem;
  margin: 20px;
  //border: 1px solid #ffa409;
  position: relative;
  transition: 1s;
  transform: scale(0.9);
  background-color: #fff;
  -webkit-border-radius: 4rem;
  -moz-border-radius: 4rem;
  -ms-border-radius: 4rem;
  border-radius: 1rem;
  box-shadow: 4px 6px 10px #d6d8da;
}

.pn_testimonial_box p {
  width: 300px;
  height: 130px;
  color: #525252;
}


// .pn_testimonial_box:hover {
//   box-shadow: 4px 6px 10px #d6d8da;
//   border: 1px solid #fff;
//   transform: scale(1);
//   position: relative;
//   z-index: 1;
// }






.text-lg-left {
  text-align: left !important;
}

.android-app ul li {
  font-size: 20px;
  font-weight: 400;
  padding-bottom: 8px;
}

.list_macotte_test {
  font-size: 20px;
  font-weight: 400;
  padding-bottom: 8px;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}



.col-text {
  height: 20em;
}

.grid-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-flex-wrap: wrap;
  -webkit-justify-content: space-around;
}

.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}


@media (max-width: 640px) {
  .grid-flex {
    height: 40em;
    display: -webkit-flex;
    -webkit-flex-direction: column;
    flex-direction: column;
  }

  .col {
    order: vertical;
  }

  .col-left {
    -webkit-box-ordinal-group: 0;
    -webkit-order: 0;
    -ms-flex-order: 0;
    order: 0;
  }

  .col-text div p {
    padding: 1em;
  }

  .Aligner-item {
    width: 90%;
  }

}








































 






</style>

